import {createSlice} from '@reduxjs/toolkit';

import {invoiceBuilder} from './reducer';
import {InvoiceReportResponse, InvoiceResponse, InvoiceYearsResponse} from './thunk';

export type InvoiceState = {
  loading: number;
  invoiceYears: InvoiceYearsResponse['data'];
  invoices: InvoiceResponse['data'];
  transaction: {
    id: number;
    price: number;
    reason: string;
    type: 'addition' | 'deduction';
  }[];
  report: InvoiceReportResponse;
};
const initialState: any = {
  loading: 0,
  invoiceYears: {years: []},
  invoices: [],
  transaction: [],
  report: {
    data: ''
  }
};

export const invoiceSlicer = createSlice({
  name: 'invoice',
  initialState,
  reducers: {},
  extraReducers: invoiceBuilder
});

export default invoiceSlicer.reducer;
